import getStoreProperty from "components/ProjectNonSpecificComponents/DevTools/Functions/getStoreProperty"
import { FormInput } from "components/ProjectNonSpecificComponents/Elements/FormElements/FormInput"
import Input from "components/ProjectNonSpecificComponents/Elements/Input"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import { objectLength } from "components/ProjectNonSpecificComponents/Functions/objectLength"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import {
	IToolTipTexts,
	TDefinedToolTypes,
} from "components/ProjectSpecificComponents/Interfaces/FormsInterface"
import { observer } from "mobx-react"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import Checkbox from "../../atoms/Checkbox"

const ToolTipConfiguration = observer(() => {
	const [stringToRichText, setStringToRichText] = useState<boolean>(false)
	const store = useStore()
	const formStore = useFormStore()
	const { t } = useTranslation()
	const { settingsLanguage } = formStore
	// ! TECHNICAL DEBT: 3184, replace this with dynamic key ([parsedkey])
	let isEN = settingsLanguage == "en"
	const tooltipName = isEN ? "textEN" : "textLV"
	const { toolTipTexts } = formStore.settingsData.additionalInfo
	useEffect(() => {
		setStringToRichText(true)
	}, [settingsLanguage])

	return (
		<div>
			{objectLength(toolTipTexts) > 0 &&
				Object.entries(toolTipTexts).map(([key, value]) => {
					const parsedKey: TDefinedToolTypes = key as TDefinedToolTypes

					return (
						<div key={key} className="px-4 py-2">
							<div className="flex flex-row whitespace-nowrap w-full pb-2 justify-between">
								<p className="text-sm pr-1 pt-1">{t(`forms.tooltip.${key}`)}</p>
								<div className="flex flex-row">
									<p className="text-sm pr-1 pt-1">{t("rawText.rich-text")}</p>
									<Checkbox
										checked={value?.isRichText}
										onCheck={(checked) => {
											formStore.mergeUserFormWelcomeTextData({
												toolTipTexts: {
													...toolTipTexts,
													[key]: {
														...toolTipTexts[parsedKey],
														isRichText: checked,
													},
												},
											})
										}}
									/>
								</div>
							</div>

							<FormInput
								multiline
								wide
								value={value[tooltipName] ?? ""}
								onValueChange={(text) =>
									formStore.mergeUserFormWelcomeTextData({
										toolTipTexts: {
											...toolTipTexts,
											[key]: {
												...toolTipTexts[parsedKey],
												[tooltipName]: text,
											},
										},
									})
								}
								richText={value?.isRichText}
								convertStringToHTML={stringToRichText}
								resetConvertStringToHTMLValue={() => setStringToRichText(false)}
							/>
						</div>
					)
				})}
		</div>
	)
})

export default ToolTipConfiguration
